// extracted by mini-css-extract-plugin
var _1 = "MagicLinkView-module__animateUploadProgressBarWidth--rfUHK";
var _2 = "MagicLinkView-module__animatedBackground--DzGrX";
var _3 = "MagicLinkView-module__errorMessage--f3OYm";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "errorMessage" }
